import { Component, OnInit } from "@angular/core";
import { BlipChatService } from "../../services/blip.service";

@Component({
  selector: "ngx-button-chatbot",
  templateUrl: "./chatbot-button.component.html",
})
export class ChatbotButtonComponent implements OnInit {

  customLogin = {} as any;

  constructor(private blipChatService: BlipChatService) {}
  
  ngOnInit(): void {
    const resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
  }

  onClickButton() {
    this.blipChatService.open();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }
}